import React from 'react';

import useHpEventCta from '../../../hooks/useHpEventCta';
import { HpEventCtaVariants } from '../constants';

import styles from '../findAccommodations.scss';

const PowerDualVariant = ({ surface, event }) => {
    const {
        eventCityName,
        handleCtaClick,
        handleSearchHotelsClick,
    } = useHpEventCta({ surface, event, variant: HpEventCtaVariants.POWER_DUAL });

    return (
        <div
            className={styles.hpEventCtaContainer}
            data-testid="event-profile.find-accommodations.power-dual"
        >
            <p
                className={styles.title}
                data-testid="event-profile.find-accommodations.power-dual.title"
            >
                {eventCityName ? `Save on your stay in ${eventCityName}` : 'Save on your stay'}
            </p>
            <p
                className={styles.subtitle}
                data-testid="event-profile.find-accommodations.power-dual.subtitle"
            >
                UTR Annual Power members save more! Get up to 60% off hotels worldwide, plus $250+ in annual travel benefits.
            </p>
            <button
                type="button"
                className={`btn btn-primary btn-small text-uppercase mt16 mb16 ${styles.button}`}
                onClick={handleCtaClick}
                data-testid="event-profile.find-accommodations.power-dual.unlock-power-rates-btn"
            >
                Unlock Power Rates
            </button>
            <div
                className={styles.callout}
                data-testid="event-profile.find-accommodations.power-dual.callout"
            >
                <p
                    className={styles.calloutHeading}
                    data-testid="event-profile.find-accommodations.power-dual.callout-heading"
                >
                    Not ready to upgrade?
                </p>
                <p
                    className={styles.calloutBody}
                    data-testid="event-profile.find-accommodations.power-dual.callout-body"
                >
                    UTR users get discounted rates at 1.4M hotels through our partner <strong>Hotel Planner.</strong>
                </p>
                <button
                    type="button"
                    className={styles.calloutLink}
                    onClick={handleSearchHotelsClick}
                    data-testid="event-profile.find-accommodations.power-dual.search-hotels-link"
                >
                    Search Hotels
                </button>
            </div>
        </div>
    );
};

export default PowerDualVariant;
